import { useState } from "react";
import API from "../services/api";

const ForgotPassword = () => {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async () => {
    if (!email) return alert("Enter email");

    try {
      setLoading(true);

      await API.post("/auth/forgot-password", { email });

      alert("📩 If email exists, reset link sent");
    } catch (err) {
      alert("Something went wrong");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ maxWidth: 400, margin: "auto", padding: 20 }}>
      <h2>🔑 Forgot Password</h2>

      <input
        placeholder="Enter your email"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        style={inputStyle}
      />

      <button onClick={handleSubmit} style={btn}>
        {loading ? "Sending..." : "Send Reset Link"}
      </button>
    </div>
  );
};

const inputStyle = {
  width: "100%",
  padding: 12,
  marginTop: 20,
  borderRadius: 8,
  border: "1px solid #ddd",
};

const btn = {
  width: "100%",
  padding: 12,
  marginTop: 20,
  background: "#111",
  color: "#fff",
  border: "none",
  borderRadius: 8,
};

export default ForgotPassword;